// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Akoh","col":"styles_col__1UWw9"};